var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrillion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1963 12.1989C10.7834 12.1989 10.4056 11.9669 10.2188 11.5987L6.8608 4.98097C6.43476 4.14133 6.77004 3.11529 7.60968 2.68925C8.44913 2.2633 9.47493 2.59832 9.90116 3.43763L12.1358 7.83812L14.3738 3.43643C14.8021 2.59411 15.8318 2.25807 16.6745 2.68566C17.5177 3.11349 17.8544 4.14382 17.4265 4.98698L14.0718 11.5983C13.885 11.9665 13.5072 12.1984 13.0943 12.1984L13.0472 12.1985C13.0379 12.1988 13.0285 12.1989 13.0191 12.1989L11.1963 12.1989ZM10.7712 12.7185C10.5647 12.3609 10.1749 12.1497 9.76268 12.172L2.35978 12.5724C1.41567 12.6235 0.691712 13.4302 0.742778 14.3743C0.793814 15.3179 1.59971 16.0417 2.54332 15.9914L7.47295 15.7288L4.77927 19.8645C4.26552 20.6532 4.48829 21.7091 5.27689 22.2231C6.06568 22.7372 7.1219 22.5146 7.63603 21.7258L11.6882 15.5088C11.9136 15.163 11.9256 14.7197 11.7192 14.3622L11.7114 14.3487C11.7053 14.3369 11.6989 14.3252 11.6922 14.3135L10.7712 12.7185ZM14.3219 12.172C13.9097 12.1497 13.5199 12.3609 13.3134 12.7185L12.3924 14.3135C12.3857 14.3252 12.3793 14.3369 12.3732 14.3487L12.3654 14.3622C12.159 14.7197 12.171 15.163 12.3964 15.5088L16.4486 21.7258C16.9627 22.5146 18.0189 22.7372 18.8077 22.2231C19.5963 21.7091 19.8191 20.6532 19.3053 19.8645L16.6117 15.7288L21.5413 15.9914C22.4849 16.0417 23.2908 15.3179 23.3418 14.3743C23.3929 13.4302 22.6689 12.6235 21.7248 12.5724L14.3219 12.172Z",
    fill: "url(#paint0_linear_3644_41986)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3644_41986",
    x1: 16.9639,
    y1: 3.52892,
    x2: 6.67394,
    y2: 21.0197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107101,
    stopColor: "#FFD480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378303,
    stopColor: "#F240A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587514,
    stopColor: "#1976D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrillion);
export default __webpack_public_path__ + "static/media/trillion.38d90c84e7bfa8cf4312bb86427d3367.svg";
export { ForwardRef as ReactComponent };